import { motion } from 'framer-motion';
import React from 'react';

import style from './comparison-bars.module.scss';

const Bar = ({
  side = 'right',
  value,
  opposite,
  min = 0,
  max = 100,
  segmentWidth = 5,
  withValues = false,
  unitSign = '',
  empty = false
}) => {
  const floatMin = parseFloat(min);
  const floatMax = parseFloat(max);
  const floatResult = parseFloat(value);
  const floatOpposite = parseFloat(opposite);

  let segments = Math.ceil((floatMax - floatMin) / segmentWidth + 1);
  if (isNaN(segments)) segments = 5;

  const resultWidth = (100 / (floatMax - floatMin)) * Math.max(floatResult - floatMin, 0);
  const oppositeWidth =
    (100 / (floatMax - floatMin)) * Math.max(floatOpposite - floatMin, 0);

  const arraySegements = Array.from(Array(segments).keys());

  return (
    <div
      className={`${style.barContainer}${
        withValues ? ` ${style.barContainerValues}` : ''
      }${empty ? ` ${style.empty}` : ''}${
        side === 'right' ? ` ${style.right}` : ` ${style.left}`
      }`}
    >
      {Boolean(opposite) && !empty && (
        <motion.div
          className={`${style.oppositeBar}${
            side === 'right' ? ` ${style.right}` : ` ${style.left}`
          }`}
          animate={{ width: `${oppositeWidth}%` }}
          transition={{ duration: oppositeWidth / 90 }}
        />
      )}
      {Boolean(value) && (
        <motion.div
          className={`${style.bar}${
            side === 'right' ? ` ${style.right}` : ` ${style.left}`
          }`}
          animate={{ width: `calc(${resultWidth}% + 2px)` }}
          transition={{ duration: resultWidth / 90 }}
        />
      )}
      <div
        className={`${style.segments}${
          side === 'left' ? ` ${style.left}` : ` ${style.right}`
        }`}
      >
        {arraySegements.map((_, index) => {
          return (
            <div
              className={`${style.segmentor}${
                withValues ? ` ${style.segmentorValues}` : ''
              }`}
              key={`segment-${index}`}
            />
          );
        })}
      </div>
      {withValues && (
        <>
          <div className={`${style.minValue}${side === 'left' ? ` ${style.left}` : ''}`}>
            {min}
            {unitSign}
          </div>
          <div className={`${style.maxValue}${side === 'left' ? ` ${style.left}` : ''}`}>
            {max}
            {unitSign}
          </div>
        </>
      )}
    </div>
  );
};

export { Bar };
